import { withStyles } from '@material-ui/core';

import NoMatchMessage from './component';
import styles from './styles';

export default withStyles(styles)(NoMatchMessage);
